import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';

// Shared two-column frame for the info tabs: copy on the left, media on the right
const PDPInfoSectionLayout = t0 => {
  const $ = _c(8);
  const {
    children,
    aside: t1,
    asideHeading
  } = t0;
  const aside = t1 === undefined ? null : t1;
  let t2;
  if ($[0] !== children) {
    t2 = <div className="flex-1 min-w-0">{children}</div>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== aside || $[3] !== asideHeading) {
    t3 = !!aside && <div className="flex-1 min-w-0" data-xc="PDPInfoSectionAside">{!!asideHeading && <h3 className="text-base font-bold text-gray mt-0 mx-0 mb-6" data-xc="PDPInfoSectionAsideHeading">{asideHeading}</h3>}{aside}</div>;
    $[2] = aside;
    $[3] = asideHeading;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex flex-row gap-12 max-[767px]:flex-col max-[767px]:gap-6">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
PDPInfoSectionLayout.propTypes = {
  children: PropTypes.node,
  aside: PropTypes.node,
  asideHeading: PropTypes.string
};
export default PDPInfoSectionLayout;